import React from 'react';

function SuccesfulResetPassword(props) {
    return (
        <section>
            <div className='modal-box'>
                <h5>Password Successfully Changed</h5>
            </div>
        </section>
    );
}

export default SuccesfulResetPassword;